import { z } from 'zod';

export enum FormType {
  URL = 'url',
  TEXT = 'text',
}

export const GenerateTopicsFormValidation = z.object({
  url: z.string().optional(),
  text: z.string().optional(),
});

export type TGenerateTopicsFormType = z.infer<typeof GenerateTopicsFormValidation>;
